import { Modal, ModalBody, ModalHeader } from "flowbite-react";
import { LegalComplianceBody } from "@/features/legal/components/LegalComplianceStep/LegalComplianceBody";
import { LEGAL_COMPLIANCE_COPY } from "@/features/legal/config/legal.config";
import type { LegalCompliance, LegalDocument } from "@/features/legal/types/legalCompliance.type";
import { formatLegalComplianceUpdatedAt } from "@/features/legal/utils/formatLegalComplianceUpdatedAt";

type LegalComplianceTermsModalProps = {
  legalCompliance: LegalCompliance
  isOpen: boolean
  onClose: () => void
  onOpenDocument: (document: LegalDocument) => void
};

// Reading the terms never leaves the step: the full text of the version
// displayed opens in place.
export const LegalComplianceTermsModal = ({
  legalCompliance, isOpen, onClose, onOpenDocument,
}: LegalComplianceTermsModalProps) => (
  <Modal show={isOpen} dismissible onClose={onClose} size="3xl">
    <ModalHeader>
      <span className="block">{LEGAL_COMPLIANCE_COPY.DOCUMENT_TITLE}</span>
      <span className="block text-sm font-normal text-gray-500 dark:text-gray-400">
        {`${LEGAL_COMPLIANCE_COPY.VERSION_PREFIX} ${legalCompliance.version_label} · ${formatLegalComplianceUpdatedAt(legalCompliance.version)}`}
      </span>
    </ModalHeader>
    <ModalBody className="max-h-[70vh] overflow-y-auto">
      <LegalComplianceBody
        bodyHtml={legalCompliance.body_html}
        documents={legalCompliance.documents}
        onOpenDocument={onOpenDocument}
      />
    </ModalBody>
  </Modal>
);

LegalComplianceTermsModal.displayName = "LegalComplianceTermsModal";
